import { render, staticRenderFns } from "./ProductcenterDriveView.vue?vue&type=template&id=273f366f&scoped=true"
import script from "./ProductcenterDriveView.vue?vue&type=script&lang=js"
export * from "./ProductcenterDriveView.vue?vue&type=script&lang=js"
import style0 from "./ProductcenterDriveView.vue?vue&type=style&index=0&id=273f366f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f366f",
  null
  
)

export default component.exports